// Global Instructions Rule Applied!

import { store, AppDispatch, RootState } from '../store.ts'
import { UPDATE_RECORD_BY_SEARCH } from './constants.ts'

/**
 * Generic thunk action to update records across all Redux stores.
 * Searches for records matching searchField and searchValue, then updates them with filtered updates.
 * Only updates properties that exist on the record.
 * @param searchField - The field name to search for
 * @param searchValue - The value to match
 * @param updates - The updates to apply (will be filtered to only include existing properties)
 */
const updateReduxRecord = (searchField: string, searchValue: any, updates: Record<string, any>) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({
      type: UPDATE_RECORD_BY_SEARCH,
      payload: { searchField, searchValue, updates }
    })
  }
}

/**
 * Synchronizes updates across Redux stores using server response format.
 * Server response format: { search_field, search_value, data }
 * Runs asynchronously and non-blocking using setTimeout.
 * Uses updateReduxRecord thunk to handle all store updates.
 * @param payload - Updated data/payload from the server with search_field, search_value, and data
 */
export function syncUpdatesToState(payload: Record<string, any>): void {
  setTimeout(() => {
    try {
      const syncData = payload.data || payload

      if (!syncData.search_field || !syncData.search_value || !syncData.data) {
        return
      }

      store.dispatch(updateReduxRecord(syncData.search_field, syncData.search_value, syncData.data))
    } catch (error) {
      console.error('[syncUpdatesToState] Error syncing updates to state:', error)
    }
  }, 0)
}
